export { default } from './Rating'
export * from './Rating'
